export const FETCH_KEYS_RESPONSIBILITIES = 'FETCH_KEYS_RESPONSIBILITIES';
export const FETCH_KEYS_RESPONSIBILITIES_SUCCESS = 'FETCH_KEYS_RESPONSIBILITIES_SUCCESS';
export const FETCH_KEYS_RESPONSIBILITIES_FAILURE = 'FETCH_KEYS_RESPONSIBILITIES_FAILURE';

export const SAVE_KEYS_RESPONSIBILITIES = 'SAVE_KEYS_RESPONSIBILITIES';
export const SAVE_KEYS_RESPONSIBILITIES_SUCCESS = 'SAVE_KEYS_RESPONSIBILITIES_SUCCESS';
export const SAVE_KEYS_RESPONSIBILITIES_FAILURE = 'SAVE_KEYS_RESPONSIBILITIES_FAILURE';

export const CHANGE_KEYS_RESPONSIBILITIES_STATUS = 'CHANGE_KEYS_RESPONSIBILITIES_STATUS';
export const CHANGE_KEYS_RESPONSIBILITIES_STATUS_SUCCESS = 'CHANGE_KEYS_RESPONSIBILITIES_STATUS_SUCCESS';
export const CHANGE_KEYS_RESPONSIBILITIES_STATUS_FAILURE = 'CHANGE_KEYS_RESPONSIBILITIES_STATUS_FAILURE';
